import { NavLink } from 'react-router';

import type {
  TabsItemProps as BumblebeeTabsItemProps,
  TabsProps as BumblebeeTabsProps,
} from '@shieldpay/bumblebee/tabs';
import {
  Tabs as BumblebeeTabs,
  TabsItem as BumblebeeTabsItem,
} from '@shieldpay/bumblebee/tabs';

import type { RemoveNavLinkProperty } from '../../utilities/remove-navlink-property';

export const Tabs = (props: BumblebeeTabsProps) => {
  return <BumblebeeTabs {...props} />;
};

Tabs.Item = (props: RemoveNavLinkProperty<BumblebeeTabsItemProps>) => {
  return (
    // @ts-expect-error Fix later either with types or another approach
    <BumblebeeTabsItem {...props} NavLink={NavLink} />
  );
};
